import React, { useState, useEffect } from 'react'
import { Form , Row, Col , Input, Button  , message} from 'antd';
import axios from 'axios';
import keys from '../../../keys';
import { connect } from 'react-redux';

function UserAccount(props){
    
    const [confirmDirty, setConfirmDirty] = useState(true)
    const [username , setUsername] = useState()
    const [password , setPassword] = useState()
    const [vaidUsername , setValidUsername] = useState(false)
    
    
    
    const { getFieldDecorator , getFieldValue } = props.form;
    
    const handleConfirmBlur = e => {
        const { value } = e.target;
        console.log(value)
        setConfirmDirty(confirmDirty || !!value );
      };
    
   const  compareToFirstPassword = (rule,value, callback) => {
        const { form } = props;
        if (value && value !== form.getFieldValue('password')) {
          callback('Two passwords that you enter is inconsistent!');
        } else {
          callback();
          setPassword(value)
        }
      };
    
    const validateToNextPassword = (rule, value, callback) => {
        const { form } = this.props;
        if (value && this.state.confirmDirty) {
          form.validateFields(['confirm'], { force: true });
        }
        callback();
      };
    

    const handleClick = (e) => {
        console.log(
            {
                username,
                password
            }
        )
        axios.post(`${props.entity.server}/user/create-user/`,
            {
                username,
                password
            }
        ).then(
            response => {
                console.log(response)
                if(response.statusText === 'OK'){
                    if(response.data.is_success){
                        message.success(response.data.message)
                        props.addIdToState(response.data.id,"useraccount")
                    }
                    else
                        message.error(response.data.error)
                }
            }
        )
    }

   

    const usernameValidator = (rule,value,callback) =>{
        axios.post(`${props.entity.server}/user/is-username-available/`, {
            username : getFieldValue("username")
        }).then(
            response => {
                console.log(response)
                if(response.statusText==="OK"){
                    if(response.data.is_success){
                        setValidUsername(true)
                        callback()
                        setUsername(getFieldValue("username"))
                    }else{
                        setValidUsername(false)
                        callback("username already exist")
                    }
                }
            }
        )

    }


    return(
    <div style={{padding:"50px"}}> 
    <Form>
    <Row type="flex"  gutter={5} >  
        <Col span={6}>                         
            <Form.Item label="Username">    
             {
                 getFieldDecorator('username',{
                     rules: [{
                        required: true,
                        message: 'Please input a username!',
                     },
                    {
                        validator: usernameValidator,
                        message : "username already exisits"
                    }]
                 })(<Input/>)
             }    
            </Form.Item>
        </Col>    
    </Row>
    <Row type="flex"  gutter={5}> 
        <Col span={8}>
            <Form.Item label="Password" hasFeedback>
                {getFieldDecorator('password', {
                rules: [
                    {
                    required: true,
                    message: 'Please input your password!',
                    },
                    {
                    validator: validateToNextPassword,
                    },
                ],
                })(<Input.Password />)}
            </Form.Item>      
        </Col>
        <Col span={8}>
            <Form.Item label="Confirm Password" hasFeedback>
            {getFieldDecorator('confirm', {
                rules: [
                {
                    required: true,
                    message: 'Please confirm your password!',
                },
                {
                    validator: compareToFirstPassword,
                },
                ],
            })(<Input.Password onBlur={handleConfirmBlur} />)}
            </Form.Item>
        </Col>
    </Row>

   
  <Row type="flex"  >    
        <Col span={8}> <Button onClick={handleClick}>Create Account</Button></Col>   
  </Row>
  </Form>
</div>
    )

 }

 const mapStateToProps = state => ({entity:state.entity})

 export default Form.create({ name: 'useraccount' })(connect(mapStateToProps,null)(UserAccount));